import {
  AUTHENTICATOR_ALGORITHM,
  CSRF_COOKIE_NAME,
  CSRF_HEADER_NAME,
  ERRORS,
  FAKE_CSRF_TOKEN,
  STATUS_CODE,
} from './constants';

import { trans } from './localization/language';

export function parseDateData(logList, isLoginLogs) {
	const SG_TIMEZONE_OFFSET = -480;
	const MS_PER_MINUTE = 60000;
	Date.prototype.format = function(format) {
		var date = {
			"M+": this.getMonth() + 1,
			"d+": this.getDate(),
			"h+": this.getHours(),
			"m+": this.getMinutes(),
			"s+": this.getSeconds(),
			"q+": Math.floor((this.getMonth() + 3) / 3),
			"S+": this.getMilliseconds()
		};
		if (/(y+)/i.test(format)) {
			format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
		}
		for (var k in date) {
			if (new RegExp("(" + k + ")").test(format)) {
				format = format.replace(RegExp.$1, RegExp.$1.length == 1
					? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
			}
		}
		return format;
	}
	if(isLoginLogs) return logList.map(item=>{
		return {...item, country:item.country=='Admin/CS'?'':item.country, date:new Date(item.timestamp * 1000)}
	});
	return logList.map(item=>{
		return {
			...item,
			ip:item.ip=='0.0.0.0'?'':item.ip,
			country:item.country=='Admin/CS'?item.ip=='0.0.0.0'?'Admin/CS':'':item.country,
			date:item.date
		}
	});
}


export function removeDuplicateLogs(logList) {
	var tempLog = null;
	return logList.filter(item=> {
		if(tempLog&&tempLog.timestamp==item.timestamp&&tempLog.ip==item.ip&&tempLog.source==item.source) {
			tempLog = Object.assign({}, item);
			return;
		}
		tempLog = Object.assign({}, item);
		return item;
	});
}


//new Date(new Date(item.date).getTime()+MS_PER_MINUTE*(SG_TIMEZONE_OFFSET-(new Date().getTimezoneOffset()))).format('yyyy-MM-dd hh:mm:ss')

export function getCookie(name) {
	var cookieValue = null;
	if(document.cookie && document.cookie != '') {
		var cookies = document.cookie.split(';');
		for(var i = 0; i < cookies.length; i++) {
			var cookie = cookies[i].trim();
			if(cookie.substring(0, name.length + 1) == (name + '=')) {
				cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
				break;
			}
		}
	}
	return cookieValue;
}

export function setCookie(cname, cvalue) {
	document.cookie = cname + "=" + cvalue + "; domain=.garena.com;";
}

export function deleteCookie(name) {
	document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.garena.com; path=/;';
}

function getRequestParams() {
	var e = window.location.search.replace(/^\?/, "").split("&"), n = 0, r, i = {}, s, o, u;
	while(( r = e[n++]) !== undefined) s = r.match(/^([^=&]*)=(.*)$/), s && ( o = decodeURIComponent(s[1]), u = decodeURIComponent(s[2]), i[o] = u);
	return i;
}

export function getRequestParam(key) {
	var params = getRequestParams();
	if(key in params) {
		return params[key];
	}
	return null;
}

var public_key =
	"-----BEGIN PUBLIC KEY-----\
	MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDR7FHnzqB8syM62mAJAG7z6/ie\
	/Vz3eq0hEFHQCAd9xxQocrjDbulx1LNox5wTprvLibVRqDCMaPcXZMFRnerZC1YO\
	Ems2U3VwDMWi5s+B4qD+6jG1PB+NPzrlIt+asZtcDDkdmX1t5WgHMoubvV9tCOpH\
	YUBgF34S9lvbldXW4wIDAQAB\
	-----END PUBLIC KEY-----";

export function encryptPassword(password) {
	var encrypt = new JSEncrypt();
	encrypt.setPublicKey(public_key);
	return encrypt.encrypt(password);
}

/*
	CSS3 support
 */
var css3Support = function () {
	var transform,
		transformInCss,
		transition,
		transitionend,
		oldFlex,
		webkitVendor = 'Webkit',
		elem = document.createElement( 'div' ).style;

	function testProp( n ) {
		if ( typeof elem[ n ] === 'string' ) {
			return n;
		}

		n = webkitVendor + n.charAt( 0 ).toUpperCase() + n.slice( 1 );

		if ( typeof elem[ n ] === 'string' ) {
			return n;
		}
	}

	function testOldFlex() {
		var ret;

		elem.display = '-webkit-box';
		elem.display = '-webkit-flex';
		elem.display = 'flex';

		ret = elem.display;

		elem.display = '';

		if ( ret === '-webkit-box' ) {
			return true;
		}

		return false;
	}

	function testTrans() {
		transform = testProp( 'transform' );
		transition = testProp( 'transition' );

		if ( transform == 'WebkitTransform' ) {
			transformInCss = '-webkit-transform';
		} else {
			transformInCss = transform;
		}

		if ( transition == 'WebkitTransition' ) {
			transitionend = 'webkitTransitionEnd';
		} else {
			transitionend = 'transitionend';
		}
	}

	testTrans();
	oldFlex = testOldFlex();

	return {
		transform: transform,
		transformInCss: transformInCss,
		transition: transition,
		transitionend: transitionend,
		oldFlex: oldFlex
	};
} ();

/*
	Count down
 */
function CountDown( ele, options ) {
	var dur;
	this.ele = ele;
	options = options || {};
	dur = options.duration || 0;
	this.duration = dur;
	this.liftoffTime = dur;
	this.onExpiry = options.onExpiry || null;

	this.set( dur );
}

CountDown.prototype = {
	delay: 1000,
	set: function ( liftoffTime ) {
		this.ele.innerHTML = liftoffTime;
	},
	start: function () {
		var that = this,
			liftoffTime = this.liftoffTime,
			onExpiry = this.onExpiry;

		setTimeout( function () {
			liftoffTime--;
			if ( liftoffTime <= 0 ) {
				onExpiry && onExpiry();
			} else {
				that.liftoffTime = liftoffTime;
				that.set( liftoffTime );
				that.start();
			}
		}, this.delay );
	},
	reset: function () {
		var dur = this.duration;
		this.liftoffTime = dur;
		this.set( dur );
	}
};

/*
	Redirect to homepage after certain timer
 */

export function redirectToHome(options) {
	var display = document.getElementById('J-success-cdele');

	if (!display) {
		return;
	}

	function onExpiry(url) {
		window.location.href = url;
	}

	function init(options) {
		options = options || {};
		var url = options.url || '/',
			delay = options.delay || 5,
			cd = new CountDown(display, {
				duration: delay,
				onExpiry: function () {
					onExpiry(url);
				}
			});
		cd.start();
	}
	
	init(options);
}

/*
	Handle disable/enable get otp button
 */
export function otpCode() {
	var trigger = document.getElementById( 'J-getotp-trigger' );
	if (!trigger) {
		return;
	}

	var cddisplay,
		triggerCd,
		hint,
		sendinfo,
		cdduration = 60,
		isTriggerDisabled = false,
		triggerDisabledClass = 'content__form-getotp--disabled',
		isSendinfoHasSendedClass = false,
		infoSendedClass = 'content__sendinfo--sended';

	function getcode( options ) {
		isTriggerDisabled = true;
		if ( !isSendinfoHasSendedClass ) {
			sendinfo.classList.add( infoSendedClass );
			isSendinfoHasSendedClass = true;
		}
		trigger.classList.add( triggerDisabledClass );
		if (hint) hint.classList.add( 'content__form-getotp--cd' );
		triggerCd.reset();
		triggerCd.start();
	}

	function init( options ) {
		hint = document.getElementById( 'J-getotp-hint' );
		cddisplay = document.getElementById( 'J-getotp-cd' );
		sendinfo = document.getElementById( 'J-sendinfo' );
		triggerCd = new CountDown( cddisplay, {
			duration: cdduration,
			onExpiry: function () {
				trigger.classList.remove( triggerDisabledClass );
				if (hint) hint.classList.remove( 'content__form-getotp--cd' );
				isTriggerDisabled = false;
			}
		});
		if ( isTriggerDisabled ) {
			return;
		}
		getcode( options );
	}
	init();
}

/*
	Expand and collapse security items in security level
 */
function CollapsibleList( ele, options ) {
	var smooth = options.smooth || false;

	this.trigger = ele.trigger;
	this.content = ele.content;
	this.contentSelectedClass = options.contentSelectedClass;
	this.triggerSelectedClass = options.triggerSelectedClass;

	if ( smooth ) {
		this.rcontent = ele.rcontent;
		this.contentStopClass = options.contentStopClass;
		this.nextState = -1;
	}

	this.state = -1;
	this._init( smooth );
}

CollapsibleList.prototype = {
	_reflow: function () {
		var content = this.content,
			contentStopClass = this.contentStopClass;

		content.style.height = content.getBoundingClientRect().height + 'px';
		content.classList.add( contentStopClass );
		content.clientWidth;
		content.classList.remove( contentStopClass );
	},
	_smoothToggle: function () {
		var triggerSelectedClass = this.triggerSelectedClass,
			contentSelectedClass = this.contentSelectedClass,
			trigger = this.trigger,
			content = this.content,
			rcontent = this.rcontent,
			state = this.state,
			nextState = this.nextState,
			action;

		if ( state === 0 ) {
			this._reflow();
			if ( nextState === 1 ) {
				action = 'remove';
				content.style.height = 0;
				this.nextState = -1;
			} else {
				action = 'add';
				content.style.height = rcontent.getBoundingClientRect().height + 'px';
				this.nextState = 1;
			}
		} else {
			if ( state === 1 ) {
				action = 'remove';

				this._reflow();

				content.classList.remove( contentSelectedClass );
				content.style.display = 'block';

				this.state = 0;
				this.nextState = -1;

				content.style.height = 0;
			} else {
				action = 'add';
				content.style.height = 0;
				content.style.display = 'block';

				this.state = 0;
				this.nextState = 1;

				content.style.height = rcontent.getBoundingClientRect().height + 'px';
			}
		}

		triggerSelectedClass && trigger.classList[ action ]( triggerSelectedClass );
	},
	_toggle: function () {
		var action,
			triggerSelectedClass = this.triggerSelectedClass;

		if ( this.state == 1 ) {
			action = 'remove';
			this.state = -1;
		} else {
			action = 'add';
			this.state = 1;
		}

		triggerSelectedClass && this.trigger.classList[ action ]( triggerSelectedClass );
		this.content.classList[ action ]( this.contentSelectedClass );
	},
	_transitionEnd: function () {
		var that = this,
			contentStopClass = this.contentStopClass;

		this.content.addEventListener( css3Support.transitionend, function ( e ) {
			if ( e.propertyName !== 'height' ) {
				return;
			}

			if ( that.nextState === 1 ) {
				this.classList.add( that.contentSelectedClass );
			}

			this.classList.add( contentStopClass );
			this.style.height = '';
			this.style.display = '';
			this.clientWidth;
			this.classList.remove( contentStopClass );

			that.state = that.nextState;
		});
	},

	_init: function ( smooth ) {

		var that = this;

		if ( smooth ) {
			this._transitionEnd();
			this._toggle = this._smoothToggle;
		}

		this.trigger.addEventListener( 'click', function () {
			that._toggle();
		});
	}
};

export function sLvList() {
	var listWrap = document.getElementById('J-slv-nor-wrap');
	if (!listWrap) {
		return;
	}

	var list,
		trigger,
		listExpandedClass = 'securitylv-normal-wrap--expanded',
		listStopClass = 'securitylv-normal-wrap--stop',
		triggerExpandedClass = 'securitylv-panel--expanded';

	function init() {
		list = document.getElementById('J-slv-nor');
		trigger = document.getElementById('J-slv-nor-trigger');
		var opts = {
			contentSelectedClass: listExpandedClass,
			contentStopClass: listStopClass,
			triggerSelectedClass: triggerExpandedClass
		};
		opts.smooth = isMobile;
		new CollapsibleList({
			trigger: trigger,
			content: listWrap,
			rcontent: list
		}, opts);
	}
	init();
}

export function opLogList() {
	if ( /Android|iPhone|iPad|iPod|BlackBerry|IEMobile/i.test( navigator.userAgent ) ) {
		var listWrap = document.querySelectorAll('.J-oplog-wrap');
		if (!listWrap.length) {
			return;
		}
		var list,
			trigger,
			listExpandedClass = 'oplog-wrap--expanded',
			listStopClass = 'oplog-wrap--stop',
			triggerExpandedClass = 'oplog-title--expanded';

		function init() {
			list = document.querySelectorAll('.J-oplog');
			trigger = document.querySelectorAll('.J-oplog-trigger');

			var opts = {
					contentSelectedClass: listExpandedClass,
					contentStopClass: listStopClass,
					triggerSelectedClass: triggerExpandedClass,
					smooth: true
				},
				i = 0,
				listLen = list.length;

			for (; i < listLen; i++) {
				new CollapsibleList({
					trigger: trigger[i],
					content: listWrap[i],
					rcontent: list[i]
				}, opts);
			}
		}

		init();
	}
}

export function validateIdcard(idcard) {
	var letters = /^[0-9a-zA-Z()-]+$/;
	if(idcard.match(letters)){
		return true;
	}
	return false;
}

export function validateDate(dateString) {
	var parts = dateString.split("-");
    var day = parseInt(parts[2], 10);
    var month = parseInt(parts[1], 10);
    var year = parseInt(parts[0], 10);

    // Check the ranges of month and year
    if(year < 1900 || year > 2100 || month == 0 || month > 12)
        return false;

    var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

    // Adjust for leap years
    if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
        monthLength[1] = 29;

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
}

export function generate_captcha_key() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
		return v.toString(16);
	}).replace(/-/g,'');
}


export function fetch_csrf_protect(endpoint, content) {
    return fetch('/api/account/preflight', {
        credentials: 'same-origin',
        method: 'POST'
    }).then(
        function(response) {
            const token = getCookie(CSRF_COOKIE_NAME);
            content.headers[CSRF_HEADER_NAME] = token;
            return fetch(endpoint, content)
        }
    )
}

export function getSendOTPErrorMessage(status) {
    if (status === STATUS_CODE.OTP_LIMIT_EXCEEDED) {
        return trans('error_otp_limit');
    }
    else if (status === STATUS_CODE.OTP_STILL_COOLDOWN) {
        return trans('error_otp_cooldown');
    }
    else if (status === STATUS_CODE.INCORRECT_CAPTCHA) {
        return trans('incorrect_captcha');
    } 
    else if (status === STATUS_CODE.EMPTY_CAPTCHA) {
        return trans('input_captcha');
    }
	else if (status === STATUS_CODE.INVALID_CAPTCHA_LIMIT_EXCEEDED) {
		return trans('error_invalid_captcha_limit');
	}
    else {
        return trans('error_send_otp');
    }
}

export function getVerifyOTPErrorMessage(status) {
    return (status === STATUS_CODE.OTP_LIMIT_EXCEEDED) ? trans('error_otp_limit') : trans('error_code');
}

export function getAuthenticatorErrorMessage(status) {
    return trans('error_code');
}

export function getUnlockErrorMessage(status) {
    return (status === STATUS_CODE.OTP_LIMIT_EXCEEDED) ? trans('error_otp_limit') : trans('error_code');
}

export function timestampToString(timestamp) {
    const formatTwoDigit = n => ("0" + n).slice(-2);

    var date = new Date(timestamp * 1000);
    var dateString = date.getFullYear() + "-" + formatTwoDigit(date.getMonth() + 1) + "-" + formatTwoDigit(date.getDate());
    var timeString = date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();

    var timezoneOffset = date.getTimezoneOffset();
    var timezoneString = "GMT+" + (-1 * timezoneOffset) / 60;

    return new String(dateString + " " + timeString + " " + timezoneString);
}

function maskMobileNo(mobileNo) {
	return `****${mobileNo.slice(-4)}`;
}

export function getFullMobileNo(userInfo) {
	const { country_code, mobile_no } = userInfo;
	let full_mobile_no = `+00 ****0000`;
	if (country_code && mobile_no) {
		full_mobile_no = `+${country_code} ${maskMobileNo(mobile_no)}`;
	}
	return full_mobile_no;
}

export function getVerifyOtpAlgorithm(userInfo) {
	return userInfo
}



// WEBPACK FOOTER //
// ./app/utils.js